import RogerioMascot from './RogerioMascot'
import './rogerio-speech.css'

/** The bubble stays in document flow so the whole sentence fits on small screens. */
export default function RogerioSpeech({ pose, children, layout = 'above', className = '' }: {
  pose: string
  children: string
  layout?: 'above' | 'beside'
  className?: string
}) {
  return <figure className={`rogerio-speech rogerio-speech--${layout} ${className}`}>
    <div className="rogerio-speech__art"><RogerioMascot pose={pose} decorative /></div>
    <figcaption className="rogerio-speech__bubble">{children}</figcaption>
  </figure>
}
